export enum DisplayPrice {
    True = 0,
    False = 1,
    CheckAccountPermission = 2,
}
